module.exports = __webpack_public_path__ + "img/bp-special-offers.5ec59595.svg";